import { useMemo } from 'react';
import { Selector } from '@leverege/ui-elements';
import Unit from '@leverege/unit';
import { ns } from '@leverege/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = ns('ui-attributes.UnitSelector');
export default function UnitSelector(props) {
  const {
    unitType,
    value,
    eventData,
    onChange,
    hideDefault,
    units,
    baseUnits = false,
    ...rest
  } = props;
  const unitTypes = useMemo(() => {
    if (!unitType) {
      return null;
    }
    if (baseUnits) {
      return Unit.getBaseUnitTypes(unitType);
    }
    const types = units || Unit.getUnitsOfType(unitType);
    if (!types) {
      return null;
    }
    const ret = types.map(unit => {
      const name = unit.name && unit.name.length > 0 ? unit.name[0].toUpperCase() + unit.name.substring(1) : null;
      return {
        value: unit.symbol,
        name
      };
    });
    if (!hideDefault) {
      ret.unshift({
        value: null,
        name: t('default')
      });
    }
    return ret;
  }, [unitType, baseUnits, units, hideDefault]);
  if (!unitTypes) {
    return null;
  }
  return /*#__PURE__*/_jsx(Selector, {
    ...rest,
    value: value,
    values: unitTypes,
    onChange: onChange,
    eventData: eventData
  });
}